<template>
    <div>
        <div class="normalheader ">
            <div class="hpanel">
                <div class="panel-body">
                    <div id="hbreadcrumb" class="pull-right m-t-lg">
                        <ol class="hbreadcrumb breadcrumb">
                            <li>
                                <router-link tag="a" :to="{name:'dashboard'}">Portada</router-link>
                            </li>
                            <li>
                                <span>Hoteles</span>
                            </li>
                            <li class="active">
                                <span>{{ hotelId ? 'Editar': 'Crear'}} hotel</span>
                            </li>
                        </ol>
                    </div>
                    <h2 class="font-light m-b-xs">
                        {{ hotelId ? 'Editar': 'Crear'}} hotel
                    </h2>
                    <small>{{ hotelId ? 'Editar': 'Crear'}} hotel</small>
                </div>
            </div>

        </div>
        <div class="content">
            <div class="hpanel hviolet">
                <div class="panel-heading hbuilt">
                    Hotel
                </div>
                <div class="panel-body">
                    <div class="row">
                        <div class="col-lg-3 text-center">
                            <i class="pe-7s-culture fa-5x text-muted"></i>
                            <p class="m-t-md">
                                <strong>Hotel</strong> gestionará los viajes de sus huéspedes.<br><br>
                                <strong>Importante:</strong> Si el hotel está inactivo, los usuarios relacionados no
                                podrán iniciar sesión en el Portal Administrador.
                            </p>
                        </div>
                        <div class="col-md-9">
                            <div class="row">
                                <div class="col-md-8 form-group">
                                    <label>Nombre *</label>
                                    <custom-input tipo="text" :field="$v.form.name"/>
                                </div>
                                <div class="col-md-4 form-group">
                                    <label>Código *</label>
                                    <custom-input tipo="text" :field="$v.form.code" :longitud="4" :disabled="!!hotelId" />
                                </div>
                                <div class="col-md-4 form-group">
                                    <label>Gerente *</label>
                                    <custom-input tipo="text" :field="$v.form.manager"/>
                                </div>
                                <div class="col-md-4 form-group">
                                    <label>Correo electrónico *</label>
                                    <custom-input tipo="text" :field="$v.form.email"/>
                                </div>
                                <div class="col-md-4 form-group">
                                    <label>Celular *</label>
                                    <custom-input tipo="text" :field="$v.form.phone"/>
                                </div>
                                <div class="col-md-12 form-group">
                                    <label>Dirección *</label>
                                    <div v-if="$v.form.address.$error" class="errorTooltip">
                                        <div v-if="$v.form.address.required !== undefined && !$v.form.address.required">
                                            Requerido
                                        </div>
                                    </div>
                                    <gmap-autocomplete class="form-control m-b-md" :value="form.address"
                                                       v-custom-validations="$v.form.address.$error"
                                                       placeholder="Ingresa una dirección"
                                                       @place_changed="setPlace"
                                                       :select-first-on-enter="true">
                                    </gmap-autocomplete>
                                    <GmapMap ref="mapRef"
                                             :options="mapOptions"
                                             :center="{lat:-12.125584, lng: -77.021367}"
                                             :zoom="18"
                                             :initialZoom="true"
                                             :clickable="true" :draggable="true"
                                             style="width: 100%; height: 350px">
                                        <GmapMarker
                                            :position="hotelLatLng"
                                            :clickable="true"
                                            :draggable="true"
                                            @dragend="updateCoordinates"
                                        />
                                    </GmapMap>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="text-right">
                        <a class="btn btn-primary" :disabled="loading" @click="save">Guardar</a>
                    </div>
                </div>
            </div>
            <HotelPricing :hotelCode="form.code" v-if="$can('manage', 'config-pricing') && hotelId && form.code"/>
        </div>
    </div>
</template>

<script>

    import {HOTEL_EDIT, HOTEL_NEW, HOTEL_LIST} from "../../router/routes";
    import CustomInput from '../common/CustomInput.vue'
    import HotelPricing from './HotelPricing'
    import {email, maxLength, required} from 'vuelidate/lib/validators'
    import HotelService from '../../services/HotelService';
    import Alert from "../../util/alert";

    export default {
        name: HOTEL_EDIT.name,
        props: ['hotelId'],
        components: {CustomInput, HotelPricing},
        data: () => ({
            form: {
                name: null,
                code: null,
                address: null,
                manager: null,
                email: null,
                phone: null,
            },
            mapOptions: {},
            hotelLatLng: {lat: 0, lng: 0},
            loading: false
        }),
        watch: {
            hotelId: function () {
                if (this.hotelId) {
                    this.clear();
                    this.init(this.hotelId);
                } else
                    this.clear();
            },
        },
        validations: {
            form: {
                name: {required, maxLength: maxLength(100)},
                code: {required, maxLength: maxLength(4)},
                address: {required, maxLength: maxLength(200)},
                manager: {required, maxLength: maxLength(100)},
                email: {required, email, maxLength: maxLength(45)},
                phone: {required},
            }
        },
        methods: {
            async init(hotelId) {
                const self = this;
                try {
                    if (hotelId) {
                        const hotel = (await HotelService.getHotel(hotelId)).data.payload;
                        self.load(hotel);
                    }
                } catch (err) {
                    Alert.mensajeError(err.message);
                    self.$router.push({path: HOTEL_NEW.route});
                }
            },
            setPlace(place) {
                const self = this;
                if (!place || !place.name) {
                    self.form.address = null;
                    self.hotelLatLng = {lat: 0, lng: 0};
                    return;
                }
                self.form.address = place.formatted_address;
                self.hotelLatLng = {
                    lat: place.geometry.location.lat(),
                    lng: place.geometry.location.lng(),
                };
                self.$refs.mapRef.$mapPromise.then((map) => {
                    const bounds = new google.maps.LatLngBounds();
                    bounds.extend(self.hotelLatLng);
                    map.fitBounds(bounds);
                    map.setZoom(18);

                });
            },
            load(hotel) {
                const self = this;
                self.form.name = hotel.name;
                self.form.code = hotel.code;
                self.form.address = hotel.address;
                self.form.manager = hotel.manager;
                self.form.email = hotel.email;
                self.form.phone = hotel.phone;
                const addressParts = hotel.coords.split(',');
                self.hotelLatLng = {
                    lat: Number(addressParts[0]),
                    lng: Number(addressParts[1])
                };
                self.$refs.mapRef.$mapPromise.then((map) => {
                    const bounds = new google.maps.LatLngBounds();
                    bounds.extend(self.hotelLatLng);
                    map.fitBounds(bounds);
                    map.setZoom(18);
                });
            },
            updateCoordinates(location) {
                const self = this;
                self.hotelLatLng = {
                    lat: location.latLng.lat(),
                    lng: location.latLng.lng(),
                };
            },
            async save() {
                this.$v.$touch();
                if (this.$v.$error) return;
                const data = {
                    ...this.form, ...{coords: `${this.hotelLatLng.lat},${this.hotelLatLng.lng}`}
                };
                try {
                    this.loading = true;
                    if (this.hotelId) {
                        const hotelUpdated = (await HotelService.updateHotel(this.hotelId, data)).data.payload;
                        this.load(hotelUpdated);
                        Alert.mensajeExito("Hotel actualizado.");
                        await this.$router.push({path: HOTEL_LIST.route});
                    } else {
                        const hotelCreated = (await HotelService.addHotel(data)).data.payload;
                        await this.$router.push({path: HOTEL_LIST.route});
                        Alert.mensajeExito("Hotel creado.");
                    }
                    this.$v.$reset();
                } catch (err) {
                    Alert.mensajeError(err.message);
                } finally {
                    this.loading = false;
                }
            },
            clear() {
                const self = this;
                self.form.name = self.form.code = self.form.address =
                    self.form.manager = self.form.email = null;
                self.hotelLatLng = {lat: 0, lng: 0};
                self.form.phone = '';
            }
        },
        mounted() {
            const self = this;
            this.init(self.hotelId);
            self.$refs.mapRef.$mapPromise.then(() => {
                self.mapOptions = {
                    zoomControl: true,
                    mapTypeControl: false,
                    streetViewControl: false,
                    rotateControl: false,
                    fullscreenControl: true,
                    styles: [
                        {
                            "featureType": "poi",
                            "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                        },
                        {
                            "featureType": "transit.station",
                            "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                        }
                    ],
                }
            });
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/hotel/HotelEditor.vue